var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u-infoBlock", class: _vm.className },
    [
      _c(
        "div",
        { staticClass: "infoTitleGroup u-btn", on: { click: _vm.toggleOpen } },
        [
          _c("div", { staticClass: "infoTitle" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          !_vm.withoutDrop
            ? _c(
                "div",
                { staticClass: "toolRight" },
                [
                  _c("el-button", {
                    staticClass: "dropAction",
                    attrs: {
                      type: "text",
                      icon: _vm.isOpen
                        ? "el-icon-caret-top"
                        : "el-icon-caret-bottom",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showContent,
                expression: "showContent",
              },
            ],
            staticClass: "infoContent",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }